import { render, staticRenderFns } from "./RButton.vue?vue&type=template&id=9785f954&"
import script from "./RButton.vue?vue&type=script&lang=js&"
export * from "./RButton.vue?vue&type=script&lang=js&"
import style0 from "./RButton.vue?vue&type=style&index=0&id=9785f954&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports